exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-pills > li {\n    position: relative;\n    display: block;\n    margin-bottom: -1px;\n    background-color: #fff;\n    line-height: 1.6;\n    font-size: 1.6rem;\n    margin-top: 0 !important;\n}\n\n.nav-pills > li > a {\n    border-radius: 0 !important;\n    border: 1px solid #dedede;\n}\n\n.sidebar-item-active {\n    color: #fff !important;\n    background-color: #337ab7 !important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/SideBar.css
// module id = 683
// module chunks = 0